<template>
  <div class="ParticipantTab">

    <!-- Searchbar -->
    <input class="pt-search" type="text" v-model="search" :placeholder="$t('Teilnehmende suchen')">

    <!-- Users -->
    <div class="pt-users" @scroll="closeParticipantMenue()">
    
      <!-- Local User -->
      <div class="pt-localUser">
        <img class="pt-user-icon" :src="localUser.getUserIcon()">
        <span class="pt-user-name" :class="{'pt-user-name-moderator': localUser.getRole() === 'moderator' }">{{localUser.getName()}}</span>
      </div>

      <!-- Other Users -->
      <div class="pt-otherUsers">
        <div class="pt-otherUser" v-for="user in this.filteredUsers" :key="user.id" :value="user.id">
          <img class="pt-user-icon" :src="user.getUserIcon()">
          <span class="pt-user-name" :class="{'pt-user-name-moderator': user.getRole() === 'moderator' }">{{user.getName()}}</span>
          <md-button class="md-icon-button pt-user-button" @click="openParticipantMenue(user)">
            <DotsVertical/>
          </md-button>
        </div>
      </div>
    </div>

    <ParticipantMenue v-if="participantMenueOpen" :user="participantMenueUser" :bottom="participantMenueBottom"/>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ParticipantMenue from "@/components/flux360/SidebarComponents/ParticipantMenue";
import DotsVertical from 'vue-material-design-icons/DotsVertical.vue'

export default {
  components:{ParticipantMenue,DotsVertical},
  data: () => ({
    search: "",
    participantMenueOpen: false,
    participantMenueUser: null,
    participantMenueBottom: 0,
    mousePosY: 0,
  }),
  methods: {
    openParticipantMenue(user){
      if(user !=  this.participantMenueUser){
        this.participantMenueUser = user;
        this.participantMenueBottom = window.innerHeight - this.mousePosY + 20 + "px";
        this.participantMenueOpen = true;
      }else{
        this.closeParticipantMenue();
      }
    },
    closeParticipantMenue(){
      this.participantMenueOpen = false;
      this.participantMenueUser = null;
    },
    savePos(p){
      this.mousePosY = p.pageY;
    }
  },
  computed:{
    ...mapGetters(["users", "localUser"]),
    filteredUsers: function (){
      return this.users.filter((user) => {
        let name = user.getName().toLowerCase();
        let searchName = this.search.toLowerCase();
        return name && name.match(searchName) && user.getID() != this.localUser.getID();
      });
    },
  },
  mounted: function(){
    addEventListener('mousemove', this.savePos);
  },
  provide() {
		return {
			closeParticipantMenue: this.closeParticipantMenue,
		}
	},
}
</script>

<style scoped>
.ParticipantTab{
  padding: 0 5%;
}
.pt-search{
  background-color: #d4d0d0;
  border-radius: 15px;
  border-style: none;
  color: #414141;
  width: 100%;
  height: 35px;
  margin: 20px auto 20px auto;
  padding-left: 20px;
}
.pt-search:focus{
  outline: none;
  border-style: solid;
  border-color: #b8b6b6;
}
.pt-users{
  overflow: auto;
  height: calc(35vh - 123px);
}
.pt-localUser{
  margin-bottom: 15px;
  padding-bottom: 5px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
}
.pt-otherUser{
  margin-bottom: 15px;
}
.pt-user-icon{
  border-radius: 100%;
  height: 35px;
  width: 35px; 
  min-width: 35px;
}
.pt-user-name{
  margin-left: 10px;
  white-space: nowrap;
}
.pt-user-name-moderator{
  color: var(--primaryColor);
  font-weight: bold;
}
.pt-user-button{
  width: 20px;
  height: 40px;
  background: transparent;
  float: right;
  padding: 0;
}
.material-design-icon > .material-design-icon__svg {
  fill: black;
}
</style>